import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import ReactHtmlParser from 'react-html-parser';

import { getLang, formatPrice, getBaseUrl, getFinanceWeekly, getLeaseBiWeeklyFromOptions, getDisplayableProvinceName } from '../../../utils';
import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';

import { Tooltip } from '../../1_Atoms/Tooltip/Tooltip';

export const WheelCard = ({ Wheel, Disabled, Selected, HandleSelectedWheel, Index, showFinancePrice, ...props }) => {
    const [selected] = React.useState(Selected);
    const financial = JSON.parse(sessionStorage.getItem(Constants.FinancialObj));
    const financeTermIndex = parseInt(sessionStorage.getItem(Constants.FinanceTermIndex));
    const leaseTermIndex = parseInt(sessionStorage.getItem(Constants.LeaseTermIndex));
    const financeTerm = parseInt(sessionStorage.getItem(Constants.FinanceTerm));
    const leaseTerm = parseInt(sessionStorage.getItem(Constants.LeaseTerm));
    const { t, i18n } = useTranslation(['wheels', 'general']);

    const imagePath = getBaseUrl() + process.env.REACT_APP_BASIC_CONTENT_PATH;

    function setSelectedWheel() {
        if (Selected) {
            HandleSelectedWheel(null)
        } else {
            HandleSelectedWheel(Wheel.index)
        }
    }

    function getTotalCost(wheel) {
        if(!wheel)
            return;

        let total = wheel.price;
            total += wheel.install_cost ? wheel.install_cost : 0; 
            total += wheel.tpms ? wheel.tpms : 0;
        
        return formatPrice(total, true);
    }

    function getTooltipText(wheel) {
        const lang = getLang();
        const languageText = lang === 'en' ? 'This price includes:' : 'Ce prix inclut :';
        const basePrice = lang === 'en' ? `4 x ${wheel.title}: ` : `4 x ${wheel.title} : `
        const tpmsText = lang === 'en' ? `4 x Tire Pressure Monitoring System sensors` : `4 capteurs pour le système de surveillance de la pression des pneus`;
        const installText = lang === 'en' ? `Installation (based on average labour rates in ${getDisplayableProvinceName()})` : `Installation (calculée en fonction des frais de main-d’œuvre moyens chez les détaillants ${getDisplayableProvinceName()})`;
        const totalText = lang === 'en' ? `Total price` : `Prix total`;

        const totalCost = wheel.price //getTotalCost(wheel);

        let text = wheel.tpms && wheel.install_cost ? `${languageText}` : ``;
            text += wheel.base_msrp ?  `<br>${basePrice}${formatPrice(wheel.base_msrp, true)}` : ''; 
            text += wheel.tpms ? `<br>${tpmsText} : ${formatPrice(wheel.tpms, true)}` : '';
            text += wheel.install_cost ? `<br>${installText} : ${formatPrice(wheel.install_cost, true)}` : '';
            text += wheel.install_cost ? `<hr>${totalText} : ${formatPrice(totalCost, true)}` : ``;

        return text;
    }

    return (
        <button onClick={() => setSelectedWheel()} className={`wheel-card ${Selected ? 'wheel-card-selected' : ''}`} disabled={Disabled}>
            {Wheel ? <span className="wheel-card__content">
                <img className="wheel-card__img" alt={Wheel.name} src={`${imagePath}/wheels/${Wheel.image.thumbnail}`} />
                <span className={Selected ? "wheel-card__selected-indicator selected" : "wheel-card__selected-indicator"}><i className="mz-svg mz-svg--white mz-svg-checkmark"></i></span>
                <span className="wheel-card__info">
                    <span className="wheel-card__title">{Wheel.title}</span>
                    <span className="wheel-card__price">{Wheel.price !== 0 ? `+ ${formatPrice(Wheel.price)}` : ''} <span className="nowrap">{Wheel.price !== 0 ?
                        `(${showFinancePrice ?
                            `${getFinanceWeekly(Wheel.price, financial.apr[financeTermIndex].rate, financial.apr[financeTermIndex].term)}${t("general:week")}` :
                            `${getLeaseBiWeeklyFromOptions(Wheel.price, financial.apr[leaseTermIndex].leaseRate, financial.apr[leaseTermIndex].term)}${t("general:bi_week")}`})` : ''}
                            {getTooltipText(Wheel) ? <Tooltip TooltipText={ReactHtmlParser(getTooltipText(Wheel))} /> : ``}</span>
                    </span>

                </span>
            </span> : null}
        </button>
    )

}


export default WheelCard;

WheelCard.propTypes = {
    HandleSelectedWheel: PropTypes.func,
}

WheelCard.defaultProps = {
    HandleSelectedWheel: () => { },
};